import React from 'react'
import { Button, Form } from 'react-bootstrap'

const FixedSourceForm = ({ handleChange, fixedSourceForm, handleSubmit, handleCancel }) => {
    return (
        <>
            <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                    <Form.Label>Fixed Source Name<span className="text-danger">*</span></Form.Label>
                    <Form.Control
                        type="text"
                        name="title"
                        value={fixedSourceForm.title}
                        onChange={handleChange}
                        required
                    />
                </Form.Group>
                <div className="d-flex justify-content-end gap-2">
                    <Button variant="secondary" onClick={handleCancel}>
                        Cancel
                    </Button>
                    <Button type="submit" variant="primary">
                        {fixedSourceForm.id ?'Update':'Submit'}
                    </Button>
                </div>
            </Form>

        </>
    )
}

export default FixedSourceForm
